var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.129 32V21C64.129 19.1435 63.4153 17.363 62.1449 16.0503C60.8745 14.7375 59.1515 14 57.3548 14H21.5484C17.9551 14 14.509 15.475 11.9682 18.1005C9.42742 20.726 8 24.287 8 28V48C8 51.713 9.42742 55.274 11.9682 57.8995C14.509 60.525 17.9551 62 21.5484 62H57.3548C59.1515 62 60.8745 61.2625 62.1449 59.9497C63.4153 58.637 64.129 56.8565 64.129 55V50",
    stroke: "url(#paint0_linear_4169_9817)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3231 32H64.1295C65.1561 32 66.1407 32.4214 66.8667 33.1716C67.5926 33.9217 68.0005 34.9391 68.0005 36V40C68.0005 41.0609 67.5926 42.0783 66.8667 42.8284C66.1407 43.5786 65.1561 44 64.1295 44H58.3231C56.7831 44 55.3062 43.3679 54.2173 42.2426C53.1284 41.1174 52.5166 39.5913 52.5166 38C52.5166 36.4087 53.1284 34.8826 54.2173 33.7574C55.3062 32.6321 56.7831 32 58.3231 32Z",
    stroke: "url(#paint1_linear_4169_9817)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3223 40C59.3913 40 60.2578 39.1046 60.2578 38C60.2578 36.8954 59.3913 36 58.3223 36C57.2534 36 56.3868 36.8954 56.3868 38C56.3868 39.1046 57.2534 40 58.3223 40Z",
    fill: "url(#paint2_linear_4169_9817)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3157 35.1206L30.9422 28.5346C30.7607 28.3471 30.5146 28.2418 30.258 28.2418C30.0014 28.2418 29.7553 28.3471 29.5738 28.5346L23.2003 35.1206C23.0188 35.308 22.7727 35.4134 22.5161 35.4134C22.2595 35.4134 22.0134 35.308 21.8319 35.1206L20.4635 33.7066C20.2821 33.519 20.1801 33.2647 20.1801 32.9996C20.1801 32.7344 20.2821 32.4801 20.4635 32.2926L28.8896 23.5856C29.2526 23.2106 29.7448 23 30.258 23C30.7712 23 31.2634 23.2106 31.6264 23.5856L40.0525 32.2926C40.2339 32.4801 40.3359 32.7344 40.3359 32.9996C40.3359 33.2647 40.2339 33.519 40.0525 33.7066L38.6841 35.1206C38.5027 35.308 38.2566 35.4134 37.9999 35.4134C37.7433 35.4134 37.4972 35.308 37.3157 35.1206Z",
    fill: "url(#paint3_linear_4169_9817)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.258 52.9997C30.0038 53 29.7521 52.9484 29.5172 52.8478C29.2824 52.7472 29.0691 52.5997 28.8896 52.4137L20.4635 43.7067C20.2821 43.5192 20.1801 43.2649 20.1801 42.9997C20.1801 42.7346 20.2821 42.4803 20.4635 42.2927L21.8319 40.8787C22.0134 40.6913 22.2595 40.5859 22.5161 40.5859C22.7727 40.5859 23.0188 40.6913 23.2003 40.8787L29.5738 47.4647C29.7553 47.6522 30.0014 47.7575 30.258 47.7575C30.5146 47.7575 30.7607 47.6522 30.9422 47.4647L37.3157 40.8787C37.4972 40.6913 37.7433 40.5859 37.9999 40.5859C38.2566 40.5859 38.5027 40.6913 38.6841 40.8787L40.0525 42.2927C40.2339 42.4803 40.3359 42.7346 40.3359 42.9997C40.3359 43.2649 40.2339 43.5192 40.0525 43.7067L31.6264 52.4137C31.4469 52.5997 31.2336 52.7472 30.9988 52.8478C30.7639 52.9484 30.5122 53 30.258 52.9997Z",
    fill: "url(#paint4_linear_4169_9817)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3107 37.2932L30.9421 35.879C30.5642 35.4885 29.9514 35.4885 29.5735 35.879L28.2049 37.2932C27.827 37.6837 27.827 38.3169 28.2049 38.7074L29.5735 40.1216C29.9514 40.5121 30.5642 40.5121 30.9421 40.1216L32.3107 38.7074C32.6886 38.3169 32.6886 37.6837 32.3107 37.2932Z",
    fill: "url(#paint5_linear_4169_9817)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.73 37.2932L18.3615 35.879C17.9835 35.4885 17.3708 35.4885 16.9929 35.879L15.6243 37.2932C15.2463 37.6837 15.2463 38.3169 15.6243 38.7074L16.9929 40.1216C17.3708 40.5121 17.9835 40.5121 18.3615 40.1216L19.73 38.7074C20.108 38.3169 20.108 37.6837 19.73 37.2932Z",
    fill: "url(#paint6_linear_4169_9817)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8909 37.2932L43.5223 35.879C43.1443 35.4885 42.5316 35.4885 42.1537 35.879L40.7851 37.2932C40.4072 37.6837 40.4072 38.3169 40.7851 38.7074L42.1537 40.1216C42.5316 40.5121 43.1443 40.5121 43.5223 40.1216L44.8909 38.7074C45.2688 38.3169 45.2688 37.6837 44.8909 37.2932Z",
    fill: "url(#paint7_linear_4169_9817)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4169_9817",
    x1: 10.1188,
    y1: 12.7077,
    x2: 53.2602,
    y2: 70.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4169_9817",
    x1: 53.1011,
    y1: 31.6769,
    x2: 63.5489,
    y2: 47.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4169_9817",
    x1: 17.0364,
    y1: 22.1923,
    x2: 41.543,
    y2: 63.9609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIcon6);
export default __webpack_public_path__ + "static/media/ui_icon6.492e0c57cc65f56715263f1ce5e80c59.svg";
export { ForwardRef as ReactComponent };